import { coretwentyfive } from '@stepstone-genesis/dresscode';
import React from 'react';
import { AppProviders } from 'tools/genesis/AppProviders';
import { getTheme } from 'tools/genesis/getTheme';
import App from './App';
export const ClientContainer = (props) => {
    let theme = coretwentyfive;
    if (props.siteId !== undefined) {
        try {
            theme = getTheme(props.siteId);
        }
        catch {
            // Unmapped/unknown siteId -- fall back to the default theme rather than
            // crashing hydration.
        }
    }
    return (React.createElement(AppProviders, { theme: theme, isAMAEnabled: props.isAMAEnabled },
        React.createElement(App, { ...props, origin: "client" })));
};
